module.exports = __webpack_public_path__ + "img/225.missing_coffe_tea.fe91c073.svg";